<template>
    <span class="switch" :class="wrapperCss">
        <slot name="before" :on="isOn" />
        <span
            class="switch-wrapper"
            @click="toggle"
        >
            <span class="switch-handle" />
        </span>
        <slot name="after" :on="isOn" />
    </span>
</template>
<script>
  export default {
    name: 'SwitchInput',
    model: {
      prop: 'on',
      event: 'change'
    },
    props: {
      on: {
        default: false
      },
      disabled: {
        type: Boolean,
        default: false
      },
      trueValue: {
        default: true
      },
      falseValue: {
        default: false
      },
      emitOnLoad: {
        type: Boolean,
        default: true
      }
    },
    data() {
      return {
        currentValue: this.on,
        isDisabled: this.disabled
      };
    },
    computed: {
      wrapperCss() {
        return {
          disabled: this.isDisabled,
          on: this.isOn
        };
      },
      isOn() {
        return this.currentValue === this.trueValue;
      }
    },
    mounted() {
      if (this.emitOnLoad) {
        this.notify(this.ifOn(this.trueValue, this.falseValue));
      }
    },
    methods: {
      ifOn(trueValue, falseValue) {
        return this.isOn ? trueValue : falseValue;
      },
      switch() {
        return (this.currentValue = this.ifOn(
          this.falseValue,
          this.trueValue
        ));
      },
      toggle() {
        if (this.isDisabled) {
          return;
        }
        this.beforeNotify(() => {
          this.notify(this.switch());
        });
      },
      beforeNotify(callback) {
        callback();
      },
      notify(value) {
        this.$emit('change', value);
      }
    }
  };
</script>
